export default class LocalJsonDataServices {
  getschedule_day() {
    //console.log('getschedule_day');
    return fetch('data/schedule.json')
      .then((res) => res.json())
      .then((d) => d.schedule);
  }
  getboard() {
    //console.log('getschedule_day');
    return fetch('data/schedule.json')
      .then((res) => res.json())
      .then((d) => d.board);
  }
}
